module.exports = __webpack_public_path__ + "img/copy-link.897c29e.svg?v=1763034624171";